<div class="modal-body content width-600 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Closing')}}
    </span>
		<div class="content">
			<div class="layout-auto-1-auto">
				<exg-search-bar (Search)="viewTable.search($event)" [placeholder]="getRessource('ListSearchHolder')"
				                class="span-layout">
<!-- 					<ng-template #rightTemplate> -->
<!-- 						<i class="search-action far fa-filter" (click)="togglePopupMenu($event, VCviewTableFilterPopup)"></i> -->
<!-- 						<exg-popup #VCviewTableFilterPopup [closeAlways]="false" width="360"> -->
<!-- 							<app-exg-filter #VCviewTableFilterControl [MetaInfo]="viewTable.MetaInfo" -->
<!-- 							                [uiFilter]="viewTable.uiFilter" [uiSort]="viewTable.uiSort" [showFilter]="true" -->
<!-- 							                (onActivateFilter)="closePopupMenuAndReload();"></app-exg-filter> -->
<!-- 						</exg-popup> -->
<!-- 						<i class="search-action far fa-sort-alt" (click)="togglePopupMenu($event, VCviewTableSortPopup)"></i> -->
<!-- 						<exg-popup #VCviewTableSortPopup [closeAlways]="false" width="360"> -->
<!-- 							<app-exg-filter [MetaInfo]="viewTable.MetaInfo" [uiFilter]="viewTable.uiFilter" -->
<!-- 							                [uiSort]="viewTable.uiSort" [showSort]="true" -->
<!-- 							                (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter> -->
<!-- 						</exg-popup> -->
<!-- 						<i class="search-action far fa-binoculars" (click)="togglePopupMenu($event, VCviewTableSearchPopup)"></i> -->
<!-- 						<exg-popup #VCviewTableSearchPopup [closeAlways]="false" width="360"> -->
<!-- 							<app-exg-filter [MetaInfo]="viewTable.MetaInfo" [uiFilter]="viewTable.uiFilter" -->
<!-- 							                [uiSort]="viewTable.uiSort" [showSearch]="true" -->
<!-- 							                (onActivateFilter)="closePopupMenuAndReload()"></app-exg-filter> -->
<!-- 						</exg-popup> -->
<!-- 					</ng-template> -->
				</exg-search-bar>
				<div class="content app-subarea">
					<exg-data-table #VCViewTable
					                (RowChange)="viewTable.selectionChanged($event)"
					                [allowSingleSelection]="true"
					                [displayState]="viewTable.state"
					                [rowSource]="viewTable.data"
					                containerClass="grid cols-8"
					                [selectKey]="viewTable.selectKey">
						<ng-template #headerTemplate>

						</ng-template>
						<ng-template #rowTemplate let-row>

						</ng-template>
					</exg-data-table>
				</div>
				<exg-pager class="span-layout" *ngIf="viewTable.state === 0"
				           (PageChange)="viewTable.pageChanged($event)"
				           [pagingSource]="viewTable.paging">
					<ng-template #leftTemplate>
					</ng-template>
					<ng-template #rightTemplate>
						<span *ngIf="viewTable.isFiltered()">(gefiltert)</span>
					</ng-template>
				</exg-pager>
			</div>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="close()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="send()" class="md-btn"
			        [disabled]="!viewTable.selectedRow">
				{{getGlobal('Choose')}}
			</button>
		</div>
	</div>
</div>
